/**
 * @class Oskari.nba.bundle.nba-link.NbaLinkBundleInstance
 */
Oskari.clazz.define('Oskari.nba.bundle.nba-link.NbaLinkBundleInstance',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  this.registryItemData = null;
  this.linkSucceeded = false;
}, {
  /**
   * @static
   * @property __name
   */
  __name: 'nba-link',
  /**
  * Module protocol method
  *
  * @method getName
  */
  getName: function getName() {
    return this.__name;
  },
  /**
  * @method onEvent
  * @param {Oskari.mapframework.event.Event} event a Oskari event object
  * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
  */
  onEvent: function onEvent(event) {
    // "use strict";
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  /**
  * @property {Object} eventHandlers
  * @static
  */
  eventHandlers: {
    /**
     * @method MapLayerEvent
     * @param {Oskari.mapframework.event.common.MapLayerEvent} event
     */
    MapLayerEvent: function MapLayerEvent(event) {
      if (!this.linkSucceeded && this.registryItemData != null && event.getOperation() == 'add') {
        this._showRegistryItemOnMap();
      }
    }
  },
  /**
  * @method stop
  * implements BundleInstance protocol stop method
  */
  stop: function stop() {
    // "use strict";
    var me = this;
    var sandbox = me.sandbox();
    var p;
    for (p in me.eventHandlers) {
      if (me.eventHandlers.hasOwnProperty(p)) {
        sandbox.unregisterFromEventByName(me, p);
      }
    }
  },
  /**
  * DefaultExtension method for doing stuff after the bundle has started.
  *
  * @method afterStart
  */
  afterStart: function afterStart(sandbox) {
    // var conf = this.conf;
    // TODO create request and request handler for other bundles to getting external service url and make link to external service configurable
    var me = this;
    var registerService = Oskari.clazz.create('Oskari.nba.bundle.nba-link.service.RegisterService', this); // Create the register search service
    var action = me._getParameterValueFromUrl('action');
    var registryName = null;
    var registryItemId = null;
    if (action == 'showRegistryItem') {
      var params = {
        registryItemId: me._getParameterValueFromUrl('id'),
        registerName: me._getParameterValueFromUrl('registry')
      };
      console.log('params', params);
      if (params.registryItemId != null && params.registerName != null) {
        registerService.getRegistryItem(params, function (result) {
          me.registryItemData = result;
          console.log(result);
          // first attempt to show registry item on map (if proper layers are not available yet, then the attempt will be repeated)
          me._showRegistryItemOnMap();
        }, function (error) {
          console.log('error', error);
          // TODO handle error
        });
      } else {
        // TODO show error message
      }
    }
  },
  _getParameterValueFromUrl: function _getParameterValueFromUrl(paramName) {
    var regexS, regex, results;
    paramName = paramName.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    regexS = '[\\?&]' + paramName + '=([^&#]*)';
    regex = new RegExp(regexS);
    results = regex.exec(window.location.href);
    if (results != null) {
      return results[1];
    }
    return null;
  },
  _getRegistryLayerMap: function _getRegistryLayerMap() {
    var registryLayers = Oskari.getSandbox().findRegisteredModuleInstance('nba-registers').conf.registryLayers;
    var mapLayers = {};
    for (var key in registryLayers) {
      if (!Object.prototype.hasOwnProperty.call(registryLayers, key)) {
        continue;
      }
      var layer = registryLayers[key];
      if (!mapLayers[layer.name]) {
        mapLayers[layer.name] = [];
      }
      layer.mapLayerID = key;
      mapLayers[layer.name].push(layer);
    }
    return mapLayers;
  },
  _filterRegistryLayers: function _filterRegistryLayers(item, layers) {
    if (!Array.isArray(layers)) {
      return [];
    }
    if (item.rekisteri === 'Muinaisjaannosrekisteri') {
      return layers.filter(function (layer) {
        var _item$rekisterikohtai;
        return layer.classification === ((_item$rekisterikohtai = item.rekisterikohtainenLisatieto) === null || _item$rekisterikohtai === void 0 ? void 0 : _item$rekisterikohtai.laji);
      });
    }
    return layers;
  },
  _getRegistryMapItems: function _getRegistryMapItems(registryItemData) {
    var _this = this;
    var data = Array.isArray(registryItemData) ? registryItemData : [registryItemData];
    var mapLayers = this._getRegistryLayerMap();
    return data.filter(Boolean).map(function (item) {
      return {
        id: item.id,
        desc: item.nimi,
        mapLayers: _this._filterRegistryLayers(item, mapLayers[item.rekisteri]),
        bounds: [item.minX, item.minY, item.maxX, item.maxY],
        markersCoordinates: [{
          coordinateY: (item.minY + item.maxY) / 2,
          coordinateX: (item.minX + item.maxX) / 2
        }]
      };
    });
  },
  _showRegistryItemOnMap: function _showRegistryItemOnMap() {
    var me = this;
    var layers = [];
    var geoJson = {
      type: 'FeatureCollection',
      crs: {
        type: 'name',
        properties: {
          name: 'EPSG:3067'
        }
      },
      features: []
    };
    var data = me._getRegistryMapItems(me.registryItemData);
    var allLayersLoaded = true;
    for (var x = 0; x < data.length; x++) {
      for (var j = 0; j < data[x].mapLayers.length; j++) {
        var mapLayerId = data[x].mapLayers[j].mapLayerID;
        if (layers.indexOf(mapLayerId) === -1) {
          layers.push(mapLayerId);
        }
      }
      if (data[x].markersCoordinates) {
        for (var _j = 0; _j < data[x].markersCoordinates.length; _j++) {
          var lon = data[x].markersCoordinates[_j].coordinateX;
          var lat = data[x].markersCoordinates[_j].coordinateY;
          geoJson.features.push({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [lon, lat]
            }
          });
        }
      }
    }

    // showing layer for the register
    for (var i = 0; i < layers.length; i++) {
      var layer = me.sandbox.findMapLayerFromAllAvailable(layers[i]);
      if (layer != null) {
        me.sandbox.postRequestByName('AddMapLayerRequest', [layers[i], true]);
      } else {
        allLayersLoaded = false;
      }
    }

    // remove all markers
    var removeMarkersReqBuilder = Oskari.requestBuilder('MapModulePlugin.RemoveMarkersRequest');
    if (removeMarkersReqBuilder) {
      me.sandbox.request(me, removeMarkersReqBuilder());
    }
    if (geoJson.features.length > 0) {
      me.sandbox.postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [geoJson, {
        layerId: 'MARKER_LAYER',
        clearPrevious: true,
        centerTo: true,
        featureStyle: {
          image: {
            shape: 4,
            size: 5
          }
        }
      }]);
    }
    me.linkSucceeded = allLayersLoaded;
  },
  _getCentroidFromGeoJson: function _getCentroidFromGeoJson(geoJson) {
    var geoJsonFormat = new OpenLayers.Format.GeoJSON();
    var geometry = geoJsonFormat.parseGeometry(geoJson);
    return geometry.getCentroid();
  }
}, {
  extend: ['Oskari.userinterface.extension.DefaultExtension']
});